import { Component, inject, input, effect, computed } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { WK_DATATABLE_ID } from "@components/data-table/data-table.tokens";
import { WkDataTableSelectionService } from "./data-table-selection.service";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";
import { WkDataTableStoreService } from "@components/data-table/store";
import { WkDataTableRow } from "@components/data-table/rows";
import { WkDataTableCell } from "@app/shared/components/data-table/cell";
import { WkDataTableItemsService } from "./data-table-items.service";

@Component({
    selector: "tr[wk-data-table-item]",
    templateUrl: "./data-table-item.component.html",
    styleUrls: ["./data-table-item.component.scss", "../data-table-action.scss", "../data-table-row.scss"],
    host: {
        class: "wk-data-table__item wk-data-table__row",
        "[class.wk-data-table__item--empty]": "empty()",
        "[class.wk-data-table__row--clickable]": "!empty() && item() && dataTableContext.enableRowClick()",
        "[id]": "id()",
        "(click)": "onRowClicked($event)",
    },
    imports: [JumpstartComponentsModule, WkDataTableCell],
})
export class WkDataTableItem<TItem> {
    protected readonly dataTableContext = inject<WkDataTableContextService<TItem>>(WkDataTableContextService);
    private readonly dataTableSelection = inject<WkDataTableSelectionService<TItem>>(WkDataTableSelectionService);
    private readonly dataTableStore = inject(WkDataTableStoreService);
    private readonly dataTableRow = inject(WkDataTableRow, { optional: true });
    private readonly dataTableItems = inject(WkDataTableItemsService);

    protected readonly dataTableId = inject(WK_DATATABLE_ID);

    public index = input<number>(0);
    public empty = input<boolean>(false);

    protected id = computed(() => `${this.dataTableId}-row-${this.index()}`);

    protected readonly item = computed(() => this.dataTableItems.getItem(this.index()));
    protected readonly columns = computed(() => this.dataTableStore.visibleColumns());
    protected readonly hasLockedColumns = computed(() => this.dataTableStore.hasLockedColumns());

    protected onRowClicked(event: MouseEvent): void {
        const el = event.target as HTMLElement;
        const cell = el.closest("td");
        if (!cell || !cell.id) return;
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();
        const item = this.item();
        if (!item || !this.dataTableContext.enableRowClick()) return;
        this.dataTableContext.onRowClick()?.emit(item);
    }

    protected toggleSelect() {
        this.dataTableSelection.toggleSelect(this.item());
    }

    constructor() {
        effect(() => this.dataTableRow?.calcFields()(this.item()));
    }
}
